/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Hubs_Signals_Geo_Dim_Crawler_AccessInputs */

const en_directory_hubs_signals_geo_dim_crawler_access = /** @type {(inputs: Directory_Hubs_Signals_Geo_Dim_Crawler_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI crawlers can fetch the page: robots rules allow citation-critical crawlers, the page is indexable, and snippets are not restricted.`)
};

const zh_directory_hubs_signals_geo_dim_crawler_access = /** @type {(inputs: Directory_Hubs_Signals_Geo_Dim_Crawler_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 爬虫能抓取页面：robots 规则放行关键爬虫、页面可索引、摘要不受限制。`)
};

/**
* | output |
* | --- |
* | "AI crawlers can fetch the page: robots rules allow citation-critical crawlers, the page is indexable, and snippets are not restricted." |
*
* @param {Directory_Hubs_Signals_Geo_Dim_Crawler_AccessInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_hubs_signals_geo_dim_crawler_access = /** @type {((inputs?: Directory_Hubs_Signals_Geo_Dim_Crawler_AccessInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Hubs_Signals_Geo_Dim_Crawler_AccessInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_hubs_signals_geo_dim_crawler_access(inputs)
	return zh_directory_hubs_signals_geo_dim_crawler_access(inputs)
});
export { directory_hubs_signals_geo_dim_crawler_access as "directory.hubs.signals.geo.dim.crawler_access" }